import {Injectable} from '@angular/core';
import {RestServiceAbstract} from '../../base/rest.service.abstract';
import {Subject, throwError} from 'rxjs';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {ResponseModel} from '../../base/response.model';
import {Observable} from 'rxjs';
import {OwnerModel} from "../owner.model";

@Injectable({
  providedIn: 'root',
})
export class AccountService extends RestServiceAbstract {

  public ngUnsubscribe$: Subject<void> = new Subject<void>();

  public setEinvoiceEmail(idf: string, email: string, notify: boolean): Observable<ResponseModel> {
    return this.post(`/${this.USERMANAGEMENT}/idf/einvoice`, {idf, email, notify}).pipe(
      map((data: {errorCode?: string; error_code?: string; returnObject?: unknown; return_object?: unknown}) =>
        new ResponseModel({
          error_code: data.errorCode ?? data.error_code,
          return_object: data.returnObject ?? data.return_object
        })
      )
    );
  }

  public loadAllAccountdata() {
    return this.get(`/${this.USERMANAGEMENT}/idf/allAccounts`).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      })
    );
  }

  public getShippingAddress(idf: string) {
    return this.get(`/${this.USERMANAGEMENT}/idf/${idf}/shipping-address`).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  changeData(scr: any): Observable<ResponseModel> {
    return this.post(`/${this.USERMANAGEMENT}/idf/changeData`, scr).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      })
    );
  }

  changeOwner(owner: any): Observable<ResponseModel> {
    return this.post(`/${this.USERMANAGEMENT}/idf/changeOwner`, owner).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      })
    )
  }

  getAccountsData(idfs: string): Observable<ResponseModel> {
    return this.get(`/${this.USERMANAGEMENT}/admin/accounts/account-data`, {idfs: idfs}).pipe(
      takeUntil(this.ngUnsubscribe$),
      map((data: any) => {
        return new ResponseModel(data);
      })
    )
  }

  getAllAccounts(): Observable<ResponseModel> {
    return this.get(`/${this.USERMANAGEMENT}/admin/accounts`, {params: {size: 10000}}).pipe(
      takeUntil(this.ngUnsubscribe$),
      map((data: any) => {
        return new ResponseModel(data);
      })
    )
  }

  getOpeningHours(idf: string) {
    return this.get(`/${this.USERMANAGEMENT}/opening-hours?idf=${idf}`).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  saveOpeningHours(idf: string, rq: any) {
    console.log(rq);
    return this.put(`/${this.USERMANAGEMENT}/opening-hours/${idf}`, rq).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    )
  }

  public loadAllAccountLicenseData(idf: string) {
    return this.get(`/${this.USERMANAGEMENT}/account-validation?idf=${idf}`).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => new ResponseModel(data))
    );
  }

  public verifyLicenseDocument(idf: string, document: number, file ?: File) {
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }

    return this.post(`/${this.USERMANAGEMENT}/account-validation?idf=${idf}&document=${document}`, formData).pipe(
      takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public verifyAllLicenseDocument(idf: string) {
    return this.post(`/${this.USERMANAGEMENT}/account-validation/verify?idf=${idf}`, {}).pipe(takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

}
